import { useContext } from "react";
import { BotChatContext } from "../contexts/BotChatContext";

const useBotChat = () => useContext(BotChatContext);

export default useBotChat;
